import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { z } from 'zod'

import { body1, h1 } from '@nxt-insurance/ui-kit/core/typography'

import { runQuery } from '@/cms/client'
import { legalTextQuery } from '@/cms/legalText'
import { BlockContent } from '@/components/renderers/BlockContent'
import { getLocaleParts } from '@/utils/locale'
import type { PortableTextTypeComponentProps } from '@portabletext/react'
import { useQuery } from '@tanstack/react-query'

const legalTextElement = z.object({
  _key: z.string(),
  _type: z.literal('legalTextElement'),
  legalText: z.object({
    _type: z.literal('reference'),
    _ref: z.string(),
  }),
})

export const LegalTextElement = (props: {
  node: PortableTextTypeComponentProps<unknown>
  width: number
  sectionName: string
}) => {
  const value = useMemo(() => legalTextElement.parse(props.node.value), [props.node.value])
  const { locale } = useRouter()
  const [lang] = getLocaleParts(locale)
  const { data: legalText } = useQuery({
    queryKey: ['legalText', value.legalText._ref],
    queryFn: async () =>
      runQuery(legalTextQuery, {
        lang,
        id: value.legalText._ref,
      }),
    throwOnError: true,
  })
  if (!legalText) {
    return null
  }

  if (legalText.content) {
    return (
      <BlockContent
        blocks={legalText.content ?? []}
        width={props.width}
        sectionName={props.sectionName}
      />
    )
  }

  if (legalText.contentHtml) {
    return (
      <>
        <p className={h1({ type: 'secondary' })}>{legalText.heading}</p>
        <span className={body1()} dangerouslySetInnerHTML={{ __html: legalText.contentHtml }} />
      </>
    )
  }

  return null
}
